/*
 * Title: 주문내역 조회 서비스
 * Author: eto2000@gmail.com
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleServiceEditSaleDate from '../service/editSaleDate';
import GentleProxy from '../common/proxy';
import GentleAppState from '../common/appstate';
import language from '../lang';
import { getGentleLang } from '../main/main';
import Const from '../common/const';

var GentleServiceOrder = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

// 비회원 입력창
GentleServiceOrder.showForm = function(data){
    console.log('GentleServiceOrder.showForm');

    {
        const bubble = GentleUtil.notSupported();
        bubble.insert();
        return;
    }    

    const component =  Object.create(this);

    // 비회원주문상세
    const requestNonmemberDetail = function(userId, saleNum){
        console.log('requestNonmemberDetail', userId, saleNum);

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.Status){
            case 1:
                const { Data } = data;
                console.log('Data>', Data);

                render(Data);

                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
            // 안내... 
        }

        const proxy = Object.create(GentleProxy);
        const param = {userId, saleNum};

        proxy.request("nomemberDetail", param, onSuccess, onFailed );
    }
    

    // 비회원주문
    const requestNonmember = function(userName, saleNum){
        console.log('requestNonmember', userName, saleNum);

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.Status){
            case 1:
                const { Data, Status, StatusDetailCode} = data;
                console.log('Status', Status);
                if(Status == 50){
                    console.log('StatusDetailCode', StatusDetailCode);

                    if(StatusDetailCode == 208){                        
                        // 없다.
                        var bubble = Object.create( GentleComponentBubble );   
                        bubble.createComponent({
                            html: GentleLang.translateService(language.order, language.order.type.NotFoundBotNomember)
                        });     
                        bubble.insert();             
                        
                        {
                            const text = GentleLang.translate(GentleLang.type.AtomyNewProduct);
                            const option = [
                                {
                                    text: text,
                                    user: 'user',
                                    onClick: function () {
                                        console.log('애터미 신상품보기');
                                    },
                                },
                            ]
                            var button = Object.create( GentleComponentButton);
                            button.createComponent(option);
                            button.insert();
                        }
                        // {
                        //     const text = GentleLang.translate(GentleLang.type.AtomyBestProduct);
                        //     const option = [
                        //         {
                        //             text: text,
                        //             user: 'user',
                        //             onClick: function () {
                        //                 console.log('애터미 인기상품 보기');
                        //             },
                        //         },
                        //     ]
                        //     var button = Object.create( GentleComponentButton);
                        //     button.createComponent(option);
                        //     button.insert();
                        // }                        
                    }
                }else if(Data) {
                    console.log('requestNonmember Data>', Data);

                    const {OrdererInfo} = Data;
                    const {CustNo} = OrdererInfo;
    
                    requestNonmemberDetail(CustNo, saleNum);    
                }else
                

                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
            // 안내... 
        }

        const proxy = Object.create(GentleProxy);
        const param = {userName, saleNum};

        proxy.request("nomember", param, onSuccess, onFailed );
    }

    // 비회원님의 주문내역을 보여드릴게요. 먼저 주문번호와 성함을 입력해주세요.
    {
        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
            html: GentleLang.translateService(language.order, language.order.type.InputNomember)
        });     
        bubble.insert();             
    }

    const title = ''// GentleLang.translateService(language.account, language.account.type.LoginTitle);
    const placeholderNo = GentleLang.translateService(language.order, language.order.type.InputOrderno);
    const placeholderName = GentleLang.translateService(language.order, language.order.type.InputName);
    const button_title = GentleLang.translateService(language.order, language.order.type.List);

    const html = `
    <div class="card-view">
        <form class="service-form">
            <h3 class="service-title">${title}</h3>
            <input type = "text" placeholder="${placeholderNo}" name="orderno">
            <input type = "text" placeholder="${placeholderName}" name="name">
            <hr class="mt-10">
            <p class="info warning" style="display:none"></p>
            <div class="gentle-button-group">
                <div class="wide-button">
                    <button type="button" name="button" class="primary default">${button_title}</button>
                </div>
            </div>
        </form>
    </div>`;
    let $container = $(html)
    component.setPrefix("showForm");
    component.init($container);
    component.insert();

    // 바인드
    const $orderno = component.find('[name="orderno"]');
    const $name = component.find('[name="name"]');
    const $button = component.find('[name="button"]');
    // const $button = component.find('button');

    // 이벤트핸들러
    {
        $button.bind('click',function () {
            const orderno = $orderno.val();
            const name = $name.val();
            console.log('주문내역 보기', orderno, name);            

            requestNonmember(name, orderno)
        });
    }

    // 타임스탬프
    GentleUtil.timeStamp();
}

// 비회원 주문목록
GentleServiceOrder.nomembers = function(data){
    // const component =  Object.create(this);
    
    // 봇버블
    {
        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
            html: GentleLang.translateService(language.order, language.order.type.Nomember)
        });     
        bubble.insert();             
    }
    
    // 쇼핑몰에서 학인하기
    {
        const option = [
            {
                // isHidden: true,
                // isSecondary: true,
                // isCardWidth: true,
                send: false,
                text: GentleLang.translateService(language.order, language.order.type.InWeb),
                user: 'user',
                onClick: function(){
                    console.log('쇼핑몰에서 확인하기');
                    let url = (GentleAppState.isPc) ? language.url.pc.OrderConfirm : language.url.mobile.OrderConfirm;
                    window.open(url);
                },
            },
        ]
        var button = Object.create( GentleComponentButton);
        button.createComponent(option);
        //console.log(bubble);
        button.insert();

    }

    // 챗봇에서 확인하기
    {
        const option = [
            {
                // isHidden: true,
                // isSecondary: true,
                // isCardWidth: true,
                send: false,
                text: GentleLang.translateService(language.order, language.order.type.InChat),
                user: 'user',
                onClick: function(){
                    console.log('챗봇에서 더보기');
                    GentleServiceOrder.showForm();
                },
            },
        ]
        var button = Object.create( GentleComponentButton);
        button.createComponent(option);
        //console.log(bubble);
        button.insert();
    }

    GentleUtil.timeStamp();
}

// 주문상품의 공통영역으로 하단 버튼은 동적으로 구성한다.
GentleServiceOrder.orderCard = function(data){
    console.log('GentleServiceOrder.orderCard>', data)    

    
    // const {Items, SaleDate, TotalAmount, PvAmount, OrderStatusType, TrackingItems, SaleGubunType} = data;
    //2022-api-주문조회
    const { goodsNm:name, imgPath, saleDate:salesDate, totalPrice, totalPV:totalPointValue, orderStatus } = data;
    console.log('orderStatus>', orderStatus, name);

    const statusClass = GentleUtil.orderStatusClass(orderStatus);
    console.log('statusClass>', statusClass);

    let detailClass = 'primary default';
    let editClass = 'secondary default';
    
    const dateString = `${salesDate.substring(0,4)}.${salesDate.substring(4,6)}.${salesDate.substring(6,8)}`;

    const buttonDetail = GentleLang.translateService(language.product, language.product.type.OrderDetail);  
    const buttonUpdate = GentleLang.translateService(language.order, language.order.type.Update); 
    

    const totalAmount = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num: GentleUtil.comma(totalPrice)}); 
    const pvAmount = GentleUtil.comma(totalPointValue);

    /**
     case "ORD_WAIT", "ORD_PAY_WAIT" -> "미결제";
    case "ORD_PAY_FINISH" -> "주문완료";
    case "ORD_DLVP_DIRECT" -> "상품준비중";
    case "ORD_SHIP_FINISH" -> "배송중";
    case "ORD_DELI_FINISH" -> "배송완료";
    case "ORD_PAY_CANCEL" -> "주문취소";
    case "ORD_PAY_DEADLINE" -> "미결제마감";
    default -> "미결제";
    */


    let deliveryHtml = ''  
    let displayButton = 'none';
    if( orderStatus === 'ORD_WAIT' || 
        orderStatus === 'ORD_PAY_WAIT' ||
        orderStatus === 'ORD_PAY_FINISH'
    ){
        displayButton = 'block'
    }
    console.log('displayButton>', displayButton);
        
    let html = `
    <div class="card-view">
        <div class="product-container">
            <div class="state">
                <span class="time-label">${dateString}</span>
                <i class="at-badge " name="status"></i>
            </div>

            <div class="product-card">
                <figure class="product-thumbnail">
                    <img src="${imgPath}">
                </figure>
                <div class="product-summary">
                    <h3>${name}</h3>
                    <div class="flex-box-2 space-beetween">
                        <span>${totalAmount}</span>
                        <span><strong class="pv">${pvAmount}</strong> PV</span>
                    </div>
                </div>
            </div>

            <div class="gentle-button-group">
                <div class="wide-button">
                    <button type="button" class="${detailClass}" name="detail">${buttonDetail}</button>
                    ${deliveryHtml}
                    <button type="button" class="${editClass}" name="change" style="display:${displayButton}">${buttonUpdate}</button>
                </div>
            </div>
        </div>
    </div>`;

    const $card = $(html);
    $card.find('[name="detail"]').bind('click', function(){
        console.log('주문내역 자세히 보기');
        GentleServiceOrder.popupDetail(data);

    });

    $card.find('[name="delivery"]').bind('click', function(){
        console.log('배송 조회하기');
        if(TrackingItems){
            const {TrackingUrl} = TrackingItems[0];
            window.open(TrackingUrl);
        }
    });

    $card.find('[name="change"]').bind('click', function(){
        console.log('판매일자 변경하기');
        // todo : 판매일자 변경...
        GentleUtil.removeSlidePopup();

        GentleServiceEditSaleDate.popupEdit(data);
    });

    let className = GentleUtil.orderStatusClass(orderStatus.label);
    console.log('className>', className);
    console.log('$card.find(', $card.find('[name="badge"]'));
    $card.find('[name="badge"]').addClass(className);

    $card.find('[name="status"]').addClass(statusClass);

    console.log('target>', $card.find('[name="status"]'));
    
    return $card;
}

GentleServiceOrder.popupList = function(){
    console.log('GentleServiceOrder.popupList');
    const component =  Object.create(this);

    // element 참조 변수 선언
    const cards = [];
    let $list;  // 목록
    let curPage = 0;

    let total = 0;
    const PageSize = 5;

    let $buttonMore;

    // 사용안함
    // const card = function(data){
    //     console.log(data)
    //     // 2025.3 주문목록 조회
    //     const {
    //         materialCode,
    //         imgPath,
    //         name: goodsNm,
    //         saleDate:salesDate,
    //         totalPV:totalPointValue,
    //         totalPrice,
    //         orderStatus
    //     } = data;

    //     let detailClass = 'primary default';
    //     let editClass = 'secondary default';

    //     const statusClass = GentleUtil.orderStatusClass(orderStatus.label);
    
    //     const dateString = `${salesDate.substring(0,4)}.${salesDate.substring(4,6)}.${salesDate.substring(6,8)}`;
    
    //     const buttonDetail = GentleLang.translateService(language.product, language.product.type.OrderDetail); 
    //     const buttonChange = GentleLang.translateService(language.order, language.order.type.Update);
    
    //     const totalAmount = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num: GentleUtil.comma(totalPrice)}); 
    //     const pvAmount = GentleUtil.comma(totalPointValue);

    //     let htmlDelivery = ''  
    //     let displayButton = 'block';
    //     if( orderStatus.label !== '결제취소' || 
    //         orderStatus.label !== '주문취소' || 
    //         orderStatus.label !== '미결제 마감' ){
    //         displayButton = 'none'
    //     }

    //     let html = `
    //     <li>
    //         <div class="product-container">
    //             <div class="state">
    //                 <span class="time-label">${dateString}</span>
    //                 <i class="at-badge" name="status"></i>
    //             </div>
    
    //             <div class="product-card">
    //                 <figure class="product-thumbnail">
    //                     <img src="${imgPath}">
    //                 </figure>
    //                 <div class="product-summary">
    //                     <h3>${name}</h3>
    //                     <div class="flex-box-2 space-beetween">
    //                         <span>${totalAmount}</span>
    //                         <span><strong class="pv">${pvAmount}</strong> PV</span>
    //                     </div>
    //                 </div>
    //             </div>    
    //             <div class="gentle-button-group">
    //                 <div class="wide-button">
    //                     <button type="button" class="${detailClass}" name="detail">${buttonDetail}</button>
    //                     ${htmlDelivery}
    //                     <button type="button" class="${editClass}" name="change" style="display:${displayButton}>${buttonChange}</button>
    //                 </div>
    //             </div>
    //         </div>
    //     </li>`;

    //     console.log('html>', html);
    
    //     const $card = $(html);
    //     $card.find('[name="detail"]').bind('click', function(){
    //         console.log('주문내역 자세히 보기');
    //         GentleUtil.removeSlidePopup();
    //         GentleServiceOrder.popupDetail(data);
    //     });

    //     $card.find('[name="delivery"]').bind('click', function(){
    //         console.log('배송 조회하기');
    //         if(TrackingItems){
    //             const {TrackingUrl} = TrackingItems[0];
    //             window.open(TrackingUrl);
    //         }
    //     });

    //     $card.find('[name="change"]').bind('click', function(){
    //         console.log('판매일자 변경하기');
    //         GentleUtil.removeSlidePopup();
    //         console.log('data>', data);
    //         GentleServiceEditSaleDate.popupEdit(data);
    //     });

    //     $card.find('[name="status"]').addClass(statusClass);
    
    //     return $card;
    // }

    // api
    const request = function(PageNo){
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":

                const {item:items} = data;
                let resultCount = items.length
                console.log('items', items);
                if(items && items.length > 0){
                    curPage = PageNo;

                    addCard(items);

                    total += items.length;
                    // $list.append('hello');

                    if(total >= resultCount){                      
                        // todo : 버튼 감추기
                        $buttonMore.hide();
                        console.log('더 이상 없다. 버튼 감춰라');                  
                    }
                }
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);

        let startDate = new Date();
        var year = startDate.getFullYear()
        startDate.setYear(year - 1);
        const dt = new Date(startDate);
        const yyyy = dt.getFullYear();
        const mm =  GentleUtil.pad(dt.getMonth() + 1, 2);
        const dd = GentleUtil.pad(dt.getDate(), 2);
        startDate = `${yyyy}-${mm}-${dd}`;

        // const param = {period: 'YEAR', PageNo, PageSize};
        const param = {pageIdx: PageNo, rowsPerPage: PageSize, period: 'MONTH'};

        // proxy.request("global-orders", param, onSuccess, onFailed );
        proxy.request("2025-orders", param, onSuccess, onFailed );
    }

    const addCard = function(array){
        console.log('$list>', $list);
        for (let index = 0; index < array.length && index < 5; index++) {
            const element = array[index];
            // const $card = card(element);
            const $card = GentleServiceOrder.orderCard(element);
            $list.append($card);
        }
    }

    const render = function(){    
        const title = GentleLang.translateService(language.order, language.order.type.List);
        const info = GentleLang.translateService(language.order, language.order.type.ListInfo);
        const button_title = GentleLang.translateService(language.order, language.order.type.More);

        let html = `
        <div id="order-container">
            <p class="info-box"><img src="/assets/images/atomy/popup_informatino.png" srcset="/assets/images/atomy/popup_informatino@2x.png 2x">${info}</p>
            <ul class="card-list" name="list">
            </ul>    
        </div>
        <div class="margin-container">     
                <div class="gentle-button-group">
                    <div class="wide-button">
                    <button type="button" class="primary default" name="button-more">${button_title}</button>
                    </div>
                </div>       
            </div>
        `;

        const $container = $(html);

        $buttonMore = $container.find('[name="button-more"]');
        $buttonMore.bind('click', function(){
            console.log('more');
            request(curPage + 1);
        });
        GentleUtil.createSlidePopup({title, content: $container});
        $list = $container.find('[name="list"]');
    };
    render();
    request(1);
}

/**
 2025.2 - 주문목록 조회 
 "example": {
  "request": {
    "method": "GET",
    "url": "https://oadev.atomyn.com/order/searchOrderList?period=MONTH&pageIdx=1&rowsPerPage=10",
    "headers": {
      "Authorization": "Bearer {access_token}",  // 사용자 인증 토큰
      "User-Token": "{userToken}"  // 사용자 토큰
    }
  },
  "response": {
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-20T12:22:06.647948+09:00[Asia/Seoul]",  // 응답 시간
    "totalCount": 53,  // 전체 주문 수
    "pageSize": 10,  // 한 페이지당 주문 수
    "currentPage": 1,  // 현재 페이지 번호
    "items": [
      {
        "saleNum": "7012502190001047",  // 매출번호
        "saleDate": "20250220",  // 매출일자
        "jisaCode": "01",  // 지사코드
        "orderStatus": "ORD_PAY_FINISH",  // 주문상태코드
        "materialCode": "000953",  // 상품코드
        "goodsCnt": 1,  // 상품 개수
        "goodsNm": "애터미 우리밀로 만든 두부과자 (3ea)",  // 상품명
        "imgPath": "https://dev-image.atomyn.com/goods/org/953/971f26c0-8288-4481-bfb5-76412b8531b7.jpg",  // 상품 이미지 URL
        "totalPV": 700.0,  // 총 PV
        "totalPrice": 10400.0  // 총 결제 금액
      },
    ]
  }
}

 */
GentleServiceOrder.main = function(json){
    console.log('GentleServiceOrder.main',json);

    localStorage.setItem(Const.Storage.service, 'GentleServiceOrder.main');

    const component =  Object.create(this);

    const PageSize = 2;
    // api
    const request = function(PageNo){

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            
            console.log('localStorage.clearItem...')
            localStorage.setItem(Const.Storage.service, '');

            switch(data.result){
            case "200":
                console.log('Data>', data);
                render(data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);

        let startDate = new Date();
        var year = startDate.getFullYear()
        startDate.setYear(year - 1);

        const dt = new Date(startDate);
        const yyyy = dt.getFullYear();
        const mm =  GentleUtil.pad(dt.getMonth() + 1, 2);
        const dd = GentleUtil.pad(dt.getDate(), 2);
        startDate = `${yyyy}-${mm}-${dd}`;

        // 2025.3 주문목록 조회
        const param = {pageIdx: PageNo, rowsPerPage: PageSize, period: 'MONTH'};
        // proxy.request("global-orders", param, onSuccess, onFailed );
        // --> 2025.2 수정
        proxy.request("2025-orders", param, onSuccess, onFailed );
    }
    request(1);

    const render = function(data){
        let items = data.item;
        let resultCount = items.length

        console.log('resultCount>', resultCount);
        
        /* 2022-api-주문조회
        const {items, items.orderEntryCount} = data;
        */
        let htmls = [];
        // 봇버블
        {
            const name = GentleAppState.custName;
            var bubble = Object.create( GentleComponentBubble );
            const html = resultCount > 0 ?         
                GentleLang.translateService(language.order, language.order.type.FoundBot, {name}) : 
                GentleLang.translateService(language.order, language.order.type.NotFoundBot, {name});

           htmls.push(html) 
        }

        if(json && json.editSale && resultCount > 0){
            const html = GentleLang.translateService(language.sale, language.sale.type.EditSale);
            
            htmls.push(html)
        }
        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
            html: htmls}
        );     
        bubble.insert();     


        // 상품목록
        if(resultCount > 0)
        {
            const data = items[0];
            const $card = GentleServiceOrder.orderCard(data);
            component.insertElement($card);
        }

        // 주문내역 더보기
        //if(array.length > 1)
        if(resultCount > 0)// todo : 테스트용으로 풀어놓은거다. 삭제할것
        {
            const handler = function(){
                console.log('주문내역 더보기');
                GentleServiceOrder.popupList();
            };
        
            const option = [
                {
                    isHidden: true,
                    isSecondary: true,
                    isCardWidth: true,
                    text: GentleLang.translateService(language.product, language.product.type.OrderMore),
                    user: 'user',
                    onClick: handler,
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            //console.log(bubble);
            button.insert();
        }
        else{ // TotalCount = 0
            {
                const text = GentleLang.translate(GentleLang.type.AtomyNewProduct);
                const option = [
                    {
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('애터미 신상품보기');
                        },
                    },
                ]
                var button = Object.create( GentleComponentButton);
                button.createComponent(option);
                button.insert();
            }
            // {
            //     const text = GentleLang.translate(GentleLang.type.AtomyBestProduct);
            //     const option = [
            //         {
            //             text: text,
            //             user: 'user',
            //             onClick: function () {
            //                 console.log('애터미 인기상품 보기');
            //             },
            //         },
            //     ]
            //     var button = Object.create( GentleComponentButton);
            //     button.createComponent(option);
            //     button.insert();
            // }
        }
        GentleUtil.timeStamp();
    }
}

GentleServiceOrder.popupDetail = function(data){
    console.log('GentleServiceOrder.popupDetail>', data);    

    const {userName, saleNum} = data;

    // api
    const request = function(userName){
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;
                console.log('Data>', item);                        
                render(item);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {saleNum};
        console.log('param>', param);
        // proxy.request("global-order", param, onSuccess, onFailed );
        proxy.request("2025-order", param, onSuccess, onFailed );
    }
    request(userName);

    // 주문상세보기
    const render = function(data){
        console.log('render>', data);
        const title = GentleLang.translateService(language.order, language.order.type.Detail);
        const titleDelivery = GentleLang.translateService(language.order, language.order.type.DeliveryInfo);

        // title
        const titleOrderNo = GentleLang.translateService(language.order, language.order.type.No);
        const titleOrderDate = GentleLang.translateService(language.order, language.order.type.Date);
        const titleOrderPrd = GentleLang.translateService(language.order, language.order.type.Prd);
        const titleOrderPrice = GentleLang.translateService(language.order, language.order.type.Price);
        const titleOrderRcv = GentleLang.translateService(language.order, language.order.type.Receiver);
        const titleOrderAddress = GentleLang.translateService(language.order, language.order.type.Addess);
        const titleOrderMsg = GentleLang.translateService(language.order, language.order.type.Message);
        const titlePayment = GentleLang.translateService(language.order, language.order.type.Payment);
        const titleOthers = GentleLang.translateService(language.order, language.order.type.Other);
        const titlePaymentDetail = GentleLang.translateService(language.order, language.order.type.PaymentInfo);
        let titlePaymentInfo;   // 신용카드 / 계좌정보
        const titleDateComment = GentleLang.translateService(language.order, language.order.type.DateComment);
        const buttonDelivery = GentleLang.translateService(language.product, language.product.type.OrderTrans); 

        const {
            entries, 
            orderName, 
            saleDate, 
            totalPrice, 
            totalPv, 
            orderStatus, 
            saleNum, 
            payment, 
            TrackingItems,
            product,
            address,
        } = data;

        const {fullAddress, deliMemo, deliName, deliHandPhone} = address[0];

        const {imgPath} = product[0];
        // const state = GentleLang.orderStatus(orderStatus);    
        const stateClass = GentleUtil.orderStatusClass(orderStatus?.label);    

        // todo : data bind
        let memo = deliMemo ? deliMemo : '';
        let paymentIfo; // ???

        let _payAmt;
        if(orderStatus.label !== '미결제 마감') {
            console.log('결제 정보', payment[0]);
            const { cardNo, payAmt, paymentNm, bankName, ipgumAccountNo } = payment[0];
            _payAmt = payAmt;
    
            // const paymentTitle = GentleLang.translateService(language.order, language.order.type.SendMoney);
            // const amount = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(Amount)});
            // payment = `${paymentTitle} / ${amount}`;
    
            titlePaymentInfo = GentleLang.translateService(language.order, language.order.type.BankInfo)
            if(bankName){ // 결제 정보
                paymentIfo = `${bankName} ${ipgumAccountNo}`;
            }else {
                paymentIfo = `${paymentNm} ${cardNo}`;
            }
        }

        console.log('GentleUtil.comma(TotalAmount)', GentleUtil.comma(totalPrice));
        const totalAmount = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(totalPrice)});
        const pvAmount = GentleUtil.comma(totalPv);

        let htmlButtonDeliv = '';
        if(TrackingItems){
            htmlButtonDeliv = `                
            <div class="gentle-button-group">
                <div class="wide-button">
                    <button type="button" class="primary default" name="delivery">${buttonDelivery}</button>
                </div>
            </div>`;    
        }

        let htmlButtonOthers = '';
        if(GentleAppState.isLogin) {
            htmlButtonOthers = `        
            <div class="gentle-button-group">
                <div class="fixed-button">
                    <button type="button" class="primary default" name="others">${titleOthers}</button>
                </div>
            </div>
            `;    
        }

        let html = `
        <div id="order-container" class="detail">
            <div class="product-container">
                <div class="state">
                    <span class="time-label">${saleDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3')}</span>
                    <i class="at-badge" name="status"></i>
                </div>            
                <div class="product-card">
                    <figure class="product-thumbnail">
                        <img src="${imgPath}">
                    </figure>
                    <div class="product-summary">
                        <h3>${orderName}</h3>
                        <div class="flex-box-2 space-beetween">
                            <span>${totalAmount}</span>
                            <span><strong class="pv">${pvAmount}</strong> PV</span>
                        </div>
                    </div>
                </div>
                ${htmlButtonDeliv}
            </div>

            <div class="order-content">
                <h3>${titleDelivery}</h3>
                <div class="flex-box space-between">
                    <span>${titleOrderNo}</span>
                    <span>${saleNum}</span>
                </div>
                <div class="flex-box space-between">
                    <span>${titleOrderDate}</span>
                    <span>${saleDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3')}</span>
                </div>
                <div class="flex-box space-between">
                    <span>${titleOrderPrd}</span>
                    <span>${titleDateComment}</span>
                </div>
                <div class="flex-box space-between">
                    <span>${titleOrderPrice}</span>
                    <span>${totalAmount}</span>
                </div>
                <div class="flex-box space-between">
                    <span>${titleOrderRcv}</span>
                    <span>${deliName} / ${deliHandPhone}</span>
                </div>
                <div class="flex-box space-between">
                    <span>${titleOrderAddress}</span>
                    <span>${fullAddress}</span>
                </div>
                <div class="flex-box space-between">
                    <span>${titleOrderMsg}</span>
                    <span>${memo}</span>
                </div>
            </div>
            <div class="order-content border-top">
                <h3>${titlePayment}</h3>
                <div class="flex-box space-between">
                    <span>${titlePaymentDetail}</span>
                    <span>${GentleUtil.comma(_payAmt) ?? `0 원`}</span>
                </div>
                ${titlePaymentInfo && paymentIfo ? 
                    `<div class="flex-box space-between">
                    <span>${titlePaymentInfo}</span>
                    <span>${paymentIfo}</span>`
                    : ''
                }
                </div>
            </div>
            ${htmlButtonOthers}
        </div>
        `

        let $container = $(html)
        GentleUtil.createSlidePopup({
            title, 
            content: $container,
            bgColor: '#f2f5f7',
            headerBgColor: '#fff',
            autoHeight: 'fix',
        });


        // bind
        {
            // const title = GentleLang.translateService(language.product, language.product.type.OrderTrans);
            // const $div = $container.find('[name="product"]');
            // const buttons = [
            //     {
            //         title,
            //         handler: function(){
            //             console.log('배송 조회하기...web');
            //             window.open(TrackingUrl);
            //         }
            //     }
            // ];

            $container.find('[name="status"]').addClass(stateClass);
        }

        {
            $container.find('[name="delivery"]').bind('click', function(){
                console.log('배송 조회하기...web');
                // window.open(TrackingUrl); // todo 
                if(TrackingItems)
                {
                    const {TrackingUrl} = TrackingItems[0];
                    window.open(TrackingUrl);
                }    
            });
        }

        // button
        {
            $container.find('[name="others"]').bind('click', function(){
                console.log('다른 주문내역 보기');    
                GentleUtil.removeSlidePopup();
                GentleServiceOrder.popupList();
            });
        }
    };
}

export default GentleServiceOrder;